module.exports = __webpack_public_path__ + "img/shidu2.gif";